import {useReadOrderStatus} from "../../hooks/useReadOrderStatus";
import {dashboardOrderStatusInit} from "../../state";
import {DashboardOrderStatusType} from "../../interface";

export const OrderStatus = () => {
    const {data: orderStatusApiData} = useReadOrderStatus()
    const orderStatus: DashboardOrderStatusType = orderStatusApiData ?? dashboardOrderStatusInit

    return (
        <div className="content_wrap h-221px">
            <div className="fiter_top">
                <h3 className="filter_heading">금주 수주현황(총 <span>{orderStatus.totalCount}</span> 건)</h3>
                <div className="filter_toolbar"></div>
            </div>
            <table className="table table-bordered my_table table_detail mb-0">
                <tbody>
                <tr className="tr-50px">
                    <th style={{width: "24.6%"}}>수주</th>
                    <td style={{width: "25.4%"}} className="text-end">{orderStatus.orderCount}건</td>
                    <th style={{width: "24.6%"}}>이관</th>
                    <td className="text-end">{orderStatus.transferCount}건</td>
                </tr>
                <tr className="tr-50px">
                    <th>출하요청</th>
                    <td className="text-end">{orderStatus.shipmentRequestCount}건</td>
                    <th>마감</th>
                    <td className="text-end">{orderStatus.completeCount}건</td>
                </tr>
                <tr className="tr-50px">
                    <th>출하</th>
                    <td className="text-end">{orderStatus.shipmentCount}건</td>
                    <th>RMA</th>
                    <td className="text-end">{orderStatus.rmaCount}건</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}